var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.329l74.045-42.772 76.805 44.611-74.045 42.771z",
    fill: "#0E0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.329l74.045-42.772 76.805 44.611-74.045 42.771z",
    fill: "#0E0C0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "google_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 151,
    height: 88
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.328l74.045-42.772 76.805 44.611-74.045 42.772z",
    fill: "#0E0C0C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.139 109.458L29.434 80.813 76.389 53.35l48.705 28.645-46.955 27.464z",
    fill: "#FF622B"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 -2.758 56.109)",
    fill: "url(#google_svg__paint0_linear_3152_1112)",
    d: "M0 0h88.155v49.67H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 72.668 12.735)",
    fill: "url(#google_svg__paint1_linear_3152_1112)",
    d: "M0 0h93.466v49.67H0z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.59 88.235L11.96 50.697l62.307-35.991 64.628 37.538-62.306 35.991z",
    fill: "#0E0C0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.59 73.53L11.96 35.99 74.268 0l64.628 37.539-62.306 35.99z",
    fill: "url(#google_svg__paint2_linear_3152_1112)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__clip0_3152_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.099 26.94c-1.384-.798-2.506-1.317-3.795-1.781l-15.757 9.097 6.245 3.606 9.25-5.34c1.365 1.004 2.695 2.934 2.028 5.133l.178.14 8.852-.643.38-.18c.234-3.524-2.258-7.073-7.382-10.031z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.442 45.745c4.532-2.617 6.839-5.676 7.038-8.77l-9.41.682c-.426 1.39-1.636 2.888-4.135 4.33-4.438 2.563-11.14 3.042-16.54 1.475l-.18.123-1.16 5.312.12.148c8.258 1.581 17.704.49 24.267-3.3z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.391 43.46c-1.401-.4-2.728-.929-3.888-1.598-1.159-.67-2.076-1.436-2.787-2.234l-.233-.123-9.33.67-.09.146c1.144 1.974 3.053 3.83 5.765 5.395 2.711 1.566 5.926 2.668 9.344 3.328l1.22-5.583z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.289 30.069c3.15-1.82 6.642-2.259 8.995-2.3l.098-5.412c-5.62.114-11.07 1.338-15.6 3.954-6.564 3.79-8.456 9.244-5.718 14.011l9.652-.693c-2.696-3.128-1.865-6.998 2.573-9.56z",
    fill: "#EB4335"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 11.96 35.604)",
    fill: "url(#google_svg__paint3_linear_3152_1112)",
    d: "M0 0h75.073v15.175H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 76.977 73.063)",
    fill: "url(#google_svg__paint4_linear_3152_1112)",
    d: "M0 0h71.498v15.274H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__paint0_linear_3152_1112",
    x1: 56.6,
    y1: -18.365,
    x2: 49.503,
    y2: 41.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__paint1_linear_3152_1112",
    x1: 60.009,
    y1: -18.365,
    x2: 15.047,
    y2: 39.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__paint2_linear_3152_1112",
    x1: 75.428,
    y1: 0,
    x2: 75.428,
    y2: 73.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__paint3_linear_3152_1112",
    x1: 37.537,
    y1: 0,
    x2: 37.537,
    y2: 48.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__paint4_linear_3152_1112",
    x1: 35.749,
    y1: 0,
    x2: 40.981,
    y2: 126.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__clip0_3152_1112"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.86603 -.5 .86603 .5 43 36)",
    d: "M0 0h38v39H0z"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgGoogle as ReactComponent };